export default {
  home: {
    hero: {
      title: 'Sigurnosne kamere i alarmni sustavi za privatne i poslovne korisnike',
      subtitle: 'SSG Signaltechnik planira, ugrađuje i održava moderne sustave videonadzora i alarmne sustave na cijelom području Rhein-Main – od Hainburga preko Offenbacha, Frankfurta i Hanaua do Darmstadta i Groß-Geraua. Individualno prilagođeno vašem objektu, vašim potrebama i područjima koja doista treba zaštititi.',
      ctaPrimary: 'Zatražite besplatno prvo savjetovanje',
      ctaSecondary: 'Pokrenite planer kamera',
    },
    trust: {
      '0': 'Individualno planiranje',
      '1': 'Stručna ugradnja',
      '2': 'Postavljanje aplikacije',
      '3': 'Osobna skrb',
      '4': 'Privatno i poslovno',
    },
    service: {
      eyebrow: 'Naš pristup',
      title: 'Više od samog postavljanja kamera',
      lead: 'Svaki je objekt drugačiji. Zato pažljivo sagledavamo vašu situaciju prije nego što predložimo ijednu kameru. Kompletna usluga uključuje:',
      steps: {
        '0': 'Analiza potreba i objekta',
        '1': 'Odabir tipa kamere i kuta gledanja',
        '2': 'Provjera mogućih mrtvih kutova',
        '3': 'Planiranje kabela, mreže i snimanja',
        '4': 'Stručna montaža i usmjeravanje',
        '5': 'Postavljanje aplikacije i daljinskog pristupa',
        '6': 'Razumljiva obuka korisnika',
        '7': 'Trajno održavanje sustava po želji',
      },
      more: 'Otkrijte sve usluge',
    },
    solutions: {
      eyebrow: 'Vrste objekata',
      title: 'Rješenja za svaki objekt',
      lead: 'Bilo da se radi o domu, trgovini ili proizvodnoj hali – pronalazimo pravo rješenje za vaše potrebe.',
      filter: { alle: 'Svi', privat: 'Privatno', gewerbe: 'Poslovno', innen: 'Unutra', aussen: 'Vani', neu: 'Novi sustav' },
      more: 'Saznajte više',
      viewAll: 'Pogledajte sva rješenja',
    },
    area: {
      eyebrow: 'Područje djelovanja',
      title: 'Sigurnosne kamere i alarmi na cijelom području Rhein-Main',
      lead: 'Iz našeg sjedišta u Hainburgu pokrivamo cijelo gradsko područje: Frankfurt, Offenbach, Hanau, Darmstadt, Groß-Gerau i sve okolne općine. Planiranje, ugradnja i održavanje vaše kamere ili alarma – uvijek osobno i na licu mjesta.',
      viewAll: 'Pogledajte sva područja djelovanja',
    },
    tech: {
      eyebrow: 'Tehničko planiranje',
      title: 'Prava tehnika za pravi cilj',
      lead: 'Nisu važni samo megapikseli. Dobar sustav kamera nastaje kombinacijom mnogih čimbenika.',
      points: {
        '0': { title: 'Unutarnji ili vanjski prostor', desc: 'Vlaga, vremenski uvjeti i temperatura određuju izbor kamere.' },
        '1': { title: 'Svjetlo i noćni uvjeti', desc: 'Dan/noć i low-light rješenja za svaku situaciju osvjetljenja.' },
        '2': { title: 'Pregled ili prepoznavanje detalja', desc: 'Širokokutno za cjelokupan pregled ili tele za lica i registracije.' },
        '3': { title: 'Udaljenost i visina montaže', desc: 'Što više i dalje, potrebna je veća rezolucija i bolji objektiv.' },
        '4': { title: 'Kut gledanja i objektiv', desc: 'Fiksna žarišna duljina, varifokalno ili motorizirano – prema namjeni.' },
        '5': { title: 'Snimanje i pohrana', desc: 'Lokalni snimač s pohranom na disk prema potrebi.' },
        '6': { title: 'Pristup putem aplikacije', desc: 'Pregled uživo i reprodukcija putem pametnog telefona.' },
        '7': { title: 'Obavijesti o događajima', desc: 'Push poruke kod kretanja ili definiranih događaja, ovisno o sustavu.' },
        '8': { title: 'Proširivost', desc: 'Postojeći sustavi obično se mogu proširiti dodatnim kamerama.' },
      },
    },
    process: {
      eyebrow: 'Tijek',
      title: 'Kako teče vaš projekt',
      lead: 'Od prvog upita do gotovog sustava – transparentno i osobno.',
      steps: {
        '0': { title: 'Prvi razgovor', desc: 'Razgovaramo o vašim potrebama, objektu i područjima koja želite nadzirati.' },
        '1': { title: 'Obilazak i planiranje', desc: 'Termin na licu mjesta za analizu svjetla, kutova, točaka montaže i kabela.' },
        '2': { title: 'Individualna ponuda', desc: 'Dobivate transparentnu ponudu s odgovarajućom tehnikom i jasnim opsegom.' },
        '3': { title: 'Ugradnja i postavljanje', desc: 'Stručna montaža, mrežno povezivanje, postavljanje snimača i aplikacije.' },
        '4': { title: 'Obuka i skrb', desc: 'Naučite rukovati sustavom. Tu smo za vas – i nakon toga.' },
      },
    },
    refs: {
      eyebrow: 'Referentni objekti',
      title: 'Realizirani projekti',
      lead: 'Izbor iz našeg portfelja – od privatnih objekata do poslovnih sustava.',
      viewAll: 'Otkrijte sva rješenja',
      items: {
        '0': { label: 'Privatna kuća – obiteljska kuća', desc: 'Kompletan sustav sa 6 kamera, NVR-om i povezivanjem na aplikaciju' },
        '1': { label: 'Trgovina – butik', desc: 'Prodajni prostor i skladište s 4 kamere i noćnim vidom' },
        '2': { label: 'Logistika – skladište', desc: 'Nadzor velikih površina širokokutnim i PTZ kamerama' },
        '3': { label: 'Ordinacija – medicinska recepcija', desc: 'Diskretan unutarnji nadzor s maskiranjem privatnih zona' },
        '4': { label: 'Nekretnina – višestambena zgrada', desc: 'Ulaz i vanjske površine s oznakama' },
      },
    },
    care: {
      eyebrow: 'Održavanje i skrb',
      title: 'SSG Care',
      lead: 'Vaša tehnika kamera treba dugoročno pouzdano raditi. Uz SSG Care dobivate fleksibilnu pretplatu za održavanje – s mjesečnim otkazivanjem ili ugovorenim trajanjem.',
      list: {
        '0': 'Redovite provjere sustava i ažuriranja firmvera',
        '1': 'Podrška kod problema s aplikacijom i pristupom',
        '2': 'Pomoć pri promjeni pametnog telefona',
        '3': 'Provjera snimanja i pohrane',
        '4': 'Prioritetna obrada prema dogovoru',
      },
      cta: 'Otkrijte SSG Care',
    },
    planner: {
      eyebrow: 'Interaktivni alat',
      title: 'SSG planer kamera',
      lead: 'Nacrtajte prostorije ili površine, označite važna područja nadzora i isprobajte moguće položaje kamera s konusima vidnog polja. Rezultat je neobvezujuće predplaniranje za vaš razgovor s nama.',
      list: {
        '0': 'Crtanje prostorija i zidova',
        '1': 'Postavljanje ikona kamera povlačenjem',
        '2': 'Rotirajući konusi vidnog polja s ocjenom pokrivenosti',
        '3': 'Označavanje područja nadzora i privatnih zona',
        '4': 'Slanje rezultata kao upita ili ispis',
      },
      cta: 'Pokrenite planer kamera',
    },
    faq: {
      eyebrow: 'Česta pitanja',
      title: 'Što nas klijenti često pitaju',
      viewAll: 'Pogledajte sva pitanja',
      items: {
        '0': { question: 'Koliko kamera mi treba?', answer: 'To ovisi o veličini objekta, područjima nadzora i željenoj razini detalja. Nakon prvog razgovora i obilaska izrađujemo individualni prijedlog.' },
        '1': { question: 'Mogu li gledati kamere na pametnom telefonu?', answer: 'Da, kod većine modernih sustava moguć je pristup putem aplikacije. Povezivanje aplikacije postavljamo izravno tijekom ugradnje.' },
        '2': { question: 'Rade li kamere u mraku?', answer: 'Da, za vanjske prostore i slabo osvijetljene interijere postoje posebne dan/noć i low-light kamere s infracrvenim ili noćnim vidom u boji.' },
        '3': { question: 'Koliko košta sustav kamera?', answer: 'Trošak ovisi o broju kamera, objektu, kabelima i željenom opsegu funkcija. Rado izrađujemo individualnu, neobvezujuću ponudu.' },
      },
    },
    cta: {
      title: 'Otkrijmo zajedno koje rješenje odgovara vašem objektu.',
      lead: 'Nazovite nas, pišite nam ili odmah pokrenite planer kamera. Javit ćemo vam se ubrzo.',
      primary: 'Zatražite besplatno prvo savjetovanje',
      secondary: 'Pokrenite planer kamera',
    },
  },
  company: {
    solutions: {
      home: { title: 'Dom i okućnica', description: 'Od ulaznih vrata do garaže – diskretan nadzor za vaš dom.' },
      retail: { title: 'Trgovina i ugostiteljstvo', description: 'Blagajna, ulaz i skladište – profesionalno osigurano.' },
      office: { title: 'Ured i ordinacija', description: 'Recepcija, hodnici i osjetljiva područja – planirano s obzirom na privatnost.' },
      warehouse: { title: 'Skladište i logistika', description: 'Nadzor velikih površina širokokutnim kamerama i noćnim vidom.' },
      workshop: { title: 'Radionica i obrt', description: 'Robusne kamere za zahtjevnije okruženje – hale i vanjske površine.' },
      apartment: { title: 'Višestambene zgrade i nekretnine', description: 'Ulazi, stubišta i vanjske površine – za stanare i vlasnike.' },
    },
  },
};